'use client';

import { Stack } from '@mui/material';
import { useTranslations } from 'next-intl';

import { usePathname } from '@dh/i18n/navigation';
import { useBreakpoint, useTheme, useUser } from '@dh/hooks';
import { isCompact, isExpanded } from '@dh/types';
import { ProfileMenu, ProfilePicture } from '@dh/components';

import { ROUTES } from '../../../../constants';
import { FilledButton } from '../../buttons';
import { AppLogo } from '../../svgs';

import { Search } from './search/Search';
import { HeaderContainer } from './styles';

type MainAppHeaderProps = {
    onMenuClick: () => void;
};

function MainAppHeader({ onMenuClick }: MainAppHeaderProps) {
    const breakpoint = useBreakpoint();
    const isCompactLayout = isCompact(breakpoint);
    const { user, isLoading } = useUser({ withProfilePicture: true });
    const isExpandedLayout = isExpanded(breakpoint);
    const theme = useTheme();
    const t = useTranslations('general');
    const path = usePathname();

    const isLoggedIn = user !== undefined;

    const renderLogo = () => {
        return (
            <Stack pl={1.5} pr={2} py={1.25} borderRadius={'0px 28px 28px 0px'}>
                <AppLogo />
            </Stack>
        );
    };
    return (
        <HeaderContainer breakpoint={breakpoint} stretch>
            {isExpandedLayout && renderLogo()}
            <Search onMenuClick={onMenuClick} />

            {!isCompactLayout &&
                (isLoading ? (
                    <ProfilePicture />
                ) : isLoggedIn ? (
                    <ProfileMenu user={user} />
                ) : (
                    <FilledButton
                        sx={{ ml: 2 }}
                        variant='contained'
                        href={`${ROUTES.Login}?from=${path}`}
                        label={t('login')}
                        disableFocusRipple={true}
                        themeColor={theme.colors.error}
                    />
                ))}
        </HeaderContainer>
    );
}

export { MainAppHeader };
